<template>
  <div
    v-if="updateAvailable"
    class="update-banner text-center p-2 bg-warning text-dark"
  >
    <span>Hay una nueva versión disponible.</span>
    <button class="btn btn-sm btn-dark ms-2" :disabled="reloading" @click="refreshApp">
      {{ reloading ? "Actualizando…" : "Actualizar" }}
    </button>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from "vue";
import { updateAvailable, setUpdateAvailable } from "@/store/updateStore";
import {
  checkPwaVersionAndReload,
  clearPwaCaches,
  forceServiceWorkerUpdate,
  setupPwaAutoUpdateCheck,
} from "@/services/pwaUpdateService";
import { Capacitor } from "@capacitor/core";

let waitingWorker = null;
let stopAutoCheck = () => {};
const reloading = ref(false);

onMounted(() => {
  document.addEventListener("swUpdated", (event) => {
    waitingWorker = event.detail?.waiting ?? null;
    setUpdateAvailable(true);
  });

  if (!Capacitor.isNativePlatform()) {
    stopAutoCheck = setupPwaAutoUpdateCheck();
  }
});

onUnmounted(() => {
  stopAutoCheck();
});

const refreshApp = async () => {
  reloading.value = true;
  try {
    if (waitingWorker) {
      waitingWorker.postMessage({ type: "SKIP_WAITING" });
    }
    const result = await checkPwaVersionAndReload({ forceReloadIfSame: true });
    if (result === "current") {
      await forceServiceWorkerUpdate();
      await clearPwaCaches();
      window.location.reload();
    }
  } finally {
    // Si no recarga, liberar el botón
    reloading.value = false;
  }
};
</script>

<style scoped>
.update-banner {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 9999;
}
</style>
